export default __webpack_public_path__ + "static/media/about_edenbazar_2.94612eb2.png";